import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UiServices } from '../../services/ui-services';
import { ActivatedRoute } from '@angular/router';
import { RecoveryPasswordComponent } from './components/recovery-password/recovery-password.component';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.page.html',
  styleUrls: ['./auth.page.scss'],
})
export class AuthPage implements OnInit {
  loginForm: UntypedFormGroup;
  sizeMd = '5';
  pushMd = '7';
  to = 'login';
  imageBackground: string = '';
  public code = '';

  constructor(
    private route: ActivatedRoute,
    private uiSv: UiServices,
    private paramSv: ParamServicesService
  ) {}

  async ngOnInit() {
    const imageBackground = await this.paramSv.getImages('7');
    const img = imageBackground.find((x) => x.name === 'auth');
    if (img) {
      this.imageBackground = img.images[0]?.url;
    }
    const redirection = this.route.snapshot.queryParamMap.get('to');
    const token = this.route.snapshot.queryParamMap.get('recovery-pass');
    const ref = this.route.snapshot.queryParamMap.get('ref');
    if (ref === 'register') {
      this.code = this.route.snapshot.queryParamMap.get('code');
      this.changeView('register');
    }
    if (token) {
      const paramObs = this.paramSv.emitImagesObs.subscribe(async (item) => {
        if (item === 'finish') {
          paramObs.unsubscribe();
          await this.uiSv.showModal(
            RecoveryPasswordComponent,
            { token },
            'forgottPass'
          );
        }
      });
    }
    if (redirection) {
      this.to = redirection;
    }
  }

  changeView(ev) {
    if (ev === 'login') {
      this.sizeMd = '5';
      this.pushMd = '7';
      this.to = ev;
    } else {
      this.sizeMd = '9';
      this.pushMd = '4';
      this.to = ev;
    }
  }
}
